module.exports = __webpack_public_path__ + "web/img/img3.7691ffb7.png";